// extracted by mini-css-extract-plugin
module.exports = {"showMoreBtn":"style_showMoreBtn__3KxI6"};